import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner SEObanneR">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">Solutions For Search Engine Optimization</h2>
						<div className="red-border"> </div>
						<p>With the help of our top-notch SEO solutions, you may reach more of the target group and promote improved conversion rates.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
